import { useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";

export default function Loader({color, size}){
    const load=useSelector((state)=>state.loader.loading)
    if(!color){
        color="#1572e8"
    }
    if(!size){
        size=15
    }
    return(
        <div className="d-flex justify-content-center align-items-center">
            <BeatLoader loading={load} cssOverride={{display:"block"}} color={color} size={size}/>
        </div>
    )
}